module.exports = __webpack_public_path__ + "static/media/大型商场会议中心.276b8fe0.jpg";